import React from 'react'
import { AppFooter } from '../../components/AppFooter'
import { AppHeader } from '../../components/AppHeader'
import AppSubHeader from '../../components/AppSubHeader'
import { useAuth } from '../../hooks'
import { ApexMenu } from '../ApexMenu'
import styles from './styles.module.less'

export interface Props {
  children: JSX.Element | JSX.Element[]
}

const Layout = ({ children }: Props) => {
  const { handleSignout, showAppContent } = useAuth()
  return (
    <div className={`${styles.app} layout-container`}>
      <div className={styles.pageHeader}>
        <AppHeader title="Trade Processing" />
        <ApexMenu handleSignout={handleSignout} />
        {showAppContent && <AppSubHeader />}
      </div>
      <div className={styles.mainContent}>{children}</div>
      <div className={styles.pageFooter}>
        <AppFooter />
      </div>
    </div>
  )
}

export default Layout
